import React from 'react'
import { connect } from 'react-redux'
import agent from '../../agent'
import numberHelper from '../../util/numberFormatter'
import dateHelper from '../../util/dateFormatter'
import { Link } from 'react-router-dom'
import { GROUP_REMOVE_USER } from '../../constants/actionTypes'
import { Translation } from 'react-i18next'
import i18n from '../../languages/lang.js'

const mapDispatchToProps = dispatch => ({
  onDelete: (payload) => {
    dispatch({ type: GROUP_REMOVE_USER, payload })
  },
})

class UserList extends React.Component {
  constructor() {
    super()
    this.removeUser = (userkey) => {
      if (window.confirm(i18n.t('file.remove_user_confirm_text'))) {
        const payload = agent.Files.removeUserFromGroup(this.props.groupkey, userkey)
        this.props.onDelete(payload)
      }
    }
  }

  render() {
    if (!this.props.data) {
      return (
        <Translation>
          {
            (t) => (
              <div id={'loading'}>{t('system.loading')}</div>
            )
          }
        </Translation>
      )
    }

    if (this.props.data.length === 0) {
      return (
        null
      )
    }
    return (
      <Translation>
        {
          (t) => (
            <table className="table-list-small">
              <thead>
                <tr>
                  <th>{t('file.label_name')}</th>
                  <th>{t('file.label_email')}</th>
                  <th className='last'>{t('file.action')}</th>
                </tr>
              </thead>
              <tbody>
                {
                  this.props.data.map(item => {
                    return (
                      <tr key={item.key}>
                        <td className="sub">
                          {item.firstname + ' ' + item.lastname}
                        </td>
                        <td className="sub">
                          {item.email}
                        </td>
                        <td className="sub">
                          <a href='' onClick={() => this.removeUser(item.key)}>{t('file.remove_button')}</a>
                        </td>
                      </tr>
                    )
                  })
                }
              </tbody>
            </table>
          )
        }
      </Translation>
    )
  }
}

export default connect(() => ({}), mapDispatchToProps)(UserList)
